export default "__VITE_ASSET__UATrhRBA__ 1600w, __VITE_ASSET__7hyLO_gC__ 800w";